

import React from "react";

import Invoice from "../components/Invoice";


const Reports = () =>{
    return(
        <div className="container mt-6">
            <Invoice />
        </div>
    );
}


export default Reports;